import Model from "~/models/_Model";

export default class EmailTemplate extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/systemsmanager";
  }

  // Set the resource route of the model
  resource() {
    return "email-templates";
  }

  relations() {
    return {
      // system: System,
    };
  }
}
